/* -----------------------------------------------------------------------------
 * Security SM Getters
 *
 * @description - Getters of Security SM. Check ./README.md for more info.
 * -----------------------------------------------------------------------------
 */

import { getQueryParamsObj } from '@/utils/security'

export default {

  /**
   * Get CSRF token
   * @description Returns CSRF token value
   * @param {Object} state - Security SM state
   * @returns {String}
   */
  getCSRFToken (state) {
    return state.csrf
  },

  /**
   * Has parent frame
   * @description Does parent frame exist
   * @returns {Array}
   */
  hasParentFrame () {
    return window !== window.parent
  },

  /**
   * Get query params
   * @description Returns parent query params obj
   * @param {Object} state - Security SM state
   * @returns {Object}
   */
  getQueryParams (state) {
    return getQueryParamsObj(state.location.search)
  },

  /**
   * Is token verified
   * @description Returns token verified status
   * @param {Object} state - Wizard SM state
   * @returns {Boolean}
   */
  isTokenVerified (state) {
    return state.token.length > 0
  },

  /**
   * Get token
   * @description Returns token value
   * @param {Object} state - Security SM state
   * @returns {String}
   */
  getToken (state) {
    return state.token
  }

}
